import React, {createRef, RefObject} from 'react'
import Popover from "../../../gd-popover/popover-v2"
import PopoverPosition from "../../../gd-popover/popover-position"
import ControlButtonStandard from "../../../buttons/control-button/control-button-standard"
import {TOGGLE_LINK_COMMAND} from "@lexical/link"
import {sanitizeUrl} from "../../utils/url"
import {LexicalEditor} from "lexical"
import {findDOMNode} from "react-dom";

const debug = false
// const debug = "FloatingLinkEditor"

export default function FloatingLinkEditor({editor, isLink, linkUrl}: {
    editor  : LexicalEditor
    isLink  : boolean
    linkUrl : any
}): JSX.Element | null {

    if (!isLink) return null

    const popoverRef: RefObject<any> = createRef()

    const onEdit = () => {
        const node: Element | null | Text = findDOMNode(popoverRef.current)
        gd.utils.Dom.addClass(node,'is-hidden')

        debug && console.log(debug, 'onEdit')

        gd.modals.oneInput('Link URL', linkUrl, 'Edit link', (newLinkURL:string)=>{
            gd.modal.hide()

            debug && console.log(debug, 'onEdit newLinkURL', newLinkURL)

            editor.dispatchCommand(TOGGLE_LINK_COMMAND, sanitizeUrl(newLinkURL))
        }, (isOpen: boolean)=>{
            if (!isOpen) {
                gd.utils.Dom.removeClass(node,'is-hidden')
            }
        })
    }

    const onRemove = () => {
        debug && console.log(debug, 'onRemove')
        editor.dispatchCommand(TOGGLE_LINK_COMMAND, null)
    }

    const parentElement = window.getSelection()?.focusNode?.parentElement

    debug && console.log(debug, 'render', linkUrl, parentElement?.getAttribute('data-lexical-text'), parentElement)

    if (!parentElement || parentElement.getAttribute('data-lexical-text') !== 'true') return null

    const popoverPosition = new PopoverPosition({
        attachment      : "top center",
        targetAttachment: "bottom center",
    })

    return (
        <Popover className          = "flex-row-center-center p-l-4 p-r-4 p-t-4 p-b-4"
                 position               = {popoverPosition}
                 getTargetFunc          = {()=>parentElement}
                 onContainerReference   = {popoverRef}>
            <a className    = "m-l-10 m-r-10"
               href         = {linkUrl}
               title        = {linkUrl}
               target       = "_blank"
               rel          = "noopener noreferrer">
                Open link
            </a>

            <ControlButtonStandard  iconClass   = "i5-pen m-r-3"
                                    onClick     = {onEdit}/>

            <ControlButtonStandard  iconClass   = "i5-trash-alt"
                                    onClick     = {onRemove}/>
        </Popover>
    )
}
